module.exports = __webpack_public_path__ + "img/ico-dash-comming.565bed3d.svg";